import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { colors } from "theme";
import { Ptag } from "components/core";

const GradeSummaryAccordion = ({ title, children, ...props }) => {
  return (
    <Accordion
      {...props}
      style={{
        boxShadow: "none",
        border: "none",
        backgroundColor: "#F6F3FF",
        borderRadius: "10px",
      }}
    >
      <AccordionSummary
        style={{
          fontSize: "14px",
          border: "none",
          padding: "18px 30px",
          boxShadow: "none",
        }}
        expandIcon={
          <ExpandMoreIcon
            color={colors.primaryColor}
            style={{
              transform: "scale(1.8)",
            }}
          />
        }
      >
        <Ptag color={colors.primaryColor} fontSize="18px" fontWeight="bold">
          {title}
        </Ptag>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default GradeSummaryAccordion;
